import React, { Component } from "react";

export default class Cell extends Component {
  render() {
    let elementClass = "col d-flex justify-content-center align-items-center";
    let myStyle = {
      background: "white",
      lineHeight: 38 + "px",
      fontSize: 14 + "px",
      cursor: "pointer",
      color: "#333",
      margin: 8+'px',
      textAlign: 'center'
    }
    if (this.props.cell.animation) {
      if(this.props.cell.animation === 'wordPairsHelper') {
        myStyle = {
          ...myStyle,
          animation: 'wordPairsHelper',
          animationDuration: '2s',
          animationIterationCount: 1000
        }
      } else if(this.props.cell.isUsed) {
        myStyle = {
          ...myStyle,
          background: "rgb(244, 255, 199)",
        }
      }
      myStyle = {
        ...myStyle,
        animation: this.props.cell.animation + ' 1s'
      }
    } 
    return (
      <div
        className={elementClass}
        onClick={this.props.onCellClick}
        style={myStyle}
      >
        <div>
        <div>{this.props.cell.value[0]}</div>
        <div>{this.props.cell.value[1]}</div>
        </div>
      </div>
    );
  }
}
